import React from 'react';
import { NamedLink, PrimaryButton } from '../../../components';
import Slider from 'react-slick';
import classNames from 'classnames';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { ensureUser } from '../../../util/data';
import Icons from '../../../components/Icons/Icons';

function SectionSingleBlog(props) {
  const { intl, viewport, currentUser, sliderSettings } = props;

  const title = intl.formatMessage({ id: 'SectionTestimonial.title' });

  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;

  return (
    <div className={css.sectionSingleBlog}>
      <div className={css.fixedWidthContainer}>
        <PrimaryButton className={css.backBtn}>Back</PrimaryButton>
        <div className={css.featuredListingsContent}>
          <div className={css.testimonialBlock}>
            <div className={css.testimonialImg}>
              <img
                src="https://www.soulsearch.io/uploads/news-pictures/5851-sacramento-blog-post-image-20241104192609.png"
                alt=""
              />
            </div>
            <div className={css.testimonialDescription}>
              <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
              <h4>How Positive Thinking Leads to Happiness, Gratitude, and Joy</h4>
              <p>
                When life gives me lemons, I make lemonade. If there’s water in my cup, I see it as
                half full. That’s the way I’ve come to be, an optimist looking at the bright side of
                life.
              </p>
              <p>
                Over the years I have come to understand that I have a choice, I can find joy in the
                little things in life or indulge in entertaining negativity. We’re all guilty of
                allowing things that are outside of ourselves to affect our mood, it’s human!
              </p>
              <p>
                However, I find myself becoming more aware of the epidemic that is negative
                thinking. If we want to have more happiness and joy in our lives, then we need to
                shift our mindset. By changing our approach and our way of thinking, we invite more
                abundance and bliss into our experience.
              </p>
              <h5>The Power of Positive Thinking</h5>
              <p>
                Our thoughts shape the world around us. We can take charge of our circumstances or
                we can pretend that life is happening to us. Our physical reality is a reflection of
                what we are feeling on the inside.
              </p>
              <p>
                Although negative moments may rear their ugly head, how we decide to deal with them
                determines our character. By finding and honing-in on our inner strength we become
                invincible. Positive energy works like magic, it gives us a new perspective and
                raises our consciousness.
              </p>
              <p>
                We can experience all the joy and love that life has to offer if we do the work and
                chose to be positive. No matter where we are or what is taking place in the present
                moment, we have an innate power like no other. Our mind is a tool that we can
                utilize to our advantage and elevate our being.
              </p>
              <p>
                To cultivate positive energy is to delve into an awakening that pushes us to tap
                into what lies beyond the ego. It strengthens the love that we have for ourselves
                and changes the way that we see the world. Positive thinking sets the foundation for
                more contentment.
              </p>
              <h5>Life Lessons</h5>
              <p>
                The ups and downs of life can take their toll on the best of us. Although things may
                get hard, finding the silver lining in any situation will leave us feeling more
                fulfilled and at peace. If we look closely enough, we can see the goodness in any
                circumstance.
              </p>
              <p>
                Looking back on the past with sadness and anger does not serve us. If Spirit has
                taught me anything it is that looking forward with positivity is the best use of our
                energy. The biggest regret that they have shared with me is the time that they had
                wasted engaging in negativity.
              </p>
              <p>
                Holding grudges, worrying, and reveling in our negative emotions puts us out of
                alignment with who we are. Life is too short, if we listen closely to the wisdom
                that Spirit shares, we can thrive and progress as people. They are constantly
                reminding us to have faith and trust in the Universe.
              </p>
              <p>
                Many years ago, I suffered a great loss when my son departed this earth. It was one
                of the worst things that had ever happened to me. However, through my grief and
                pain, I turned it into one of the greatest growth opportunities in my life.
              </p>
              <p>
                I had to make healthy decisions that would enable me to move forward. His passing
                taught me many life lessons, instead of focusing on my pain, I became grateful for
                the love that we shared for the 20 years that he was on this earth. I felt grateful
                that I was able to have such a magnificent person in my life.
              </p>
              <p>
                I look back at our memories with fondness and live in the present where I am
                building a new relationship with him in the spirit world. I honor him through my
                life’s work by offering readings that can help parents and grief-stricken clients
                who are going through an ordeal. Reflection and positive thinking have allowed me to
                turn my pain into an opportunity to heal others.
              </p>
              <p>
                One of the most important and impactful things that we can do is to find the
                positives in life along with practicing gratitude. Being thankful for everything
                that we have contributes to our happiness, health, and prosperity. It enriches our
                lives in ways that go far beyond the surface level.
              </p>
              <h5>Messages From Spirit</h5>
              <p>
                My spiritual beliefs have set the tone for the outcome of my life. Through the good
                and the bad, I am reminded that I am the creator of my world and my reaction to
                life’s events determines the impact that it will have. Armed with this knowledge, I
                have been able to attract more blessings and help people on their journey.
              </p>
              <p>
                Never has anyone in history benefited from negative thinking. It pollutes the mind
                and breaks down the high vibrational essence that makes us spiritual beings. The
                more love and joy we feel, the closer we are to our true selves.
              </p>
              <p>
                Every day I am reminded of my power. When I choose to see the good in any situation,
                I feel more connected to Source. The gratitude that I express on a daily basis is
                rewarded with a deeper and more fulfilling relationship with my higher power.
              </p>
              <p>
                As a psychic medium, my work is centered around reading energies. When I am feeling
                positive and my mood reflects my thoughts, I can tap into the messages that I
                receive from above with ease. The effortless flow of high vibrational energy that
                stems from positive thinking empowers not only myself but also my clients.
              </p>
              <p>
                We are always being guided, the ethereal beings and Spirits around us are working to
                restore our hope and faith. The support that they offer during dark times can help
                us to see the light. With an open heart and mind, we can begin to see the positives
                in our circumstances.
              </p>
              <p>
                This is what Spirt wants to convey to us. It is possible to live a life where we can
                survive the most unimaginable pain and through the ruins, we can find beauty within.
                Tomorrow has the potential to be brighter than the day before, how we chose to look
                at it determines whether or not it will be.
              </p>
              <h5>Psychic Readings</h5>
              <p>
                There are several things that we can do to help us adopt positive habits and develop
                our way of thinking. Through trial and error, I have discovered the best method that
                can encourage positive thoughts and build upon personal development.
              </p>
              <p>
                Like many, I had struggled with blocks that were preventing me from tuning into the
                pure potential of positive thinking. By tapping into Spirit, I was able to heal old
                wounds and live a happier and more fulfilling life.
              </p>
              <p>
                My psychic abilities have allowed me to help others by using these same methods.
                Regular readings can help us to deal with stagnant energy, limiting beliefs, and any
                issues that we are facing in our lives.
              </p>
              <p>
                Once we are able to clear old energy and do the work that is needed, we open the
                door to new possibilities. A positive life is only a thought away, we simply need to
                go within to change our physical reality.
              </p>
              <p>
                The magic that we possess can move mountains and part oceans. We are eternal beings,
                our everlasting spirit and power combined with gratitude and positive thinking can
                create miracles and bring happiness and joy to all around us.
              </p>
            </div>
            <div className={css.userInfo}>
              <div className={css.userLeft}>
                <div className={css.authorDetails}>
                  <h3>John Smith</h3>
                  <p>Personal trainer, FitLife Gym</p>
                  <p>Edmonton, Canada</p>
                </div>
              </div>
            </div>
          </div>
          <div className={css.relatedPosts}>
            <div className={css.sectionHead}>
              <div className={css.leftSec}>
                <h2>Related Stories</h2>
              </div>
            </div>
            <div className={css.topStories}>
              <div className={css.featuredListingsContent}>
                <Slider {...sliderSettings}>
                  <div className={css.testimonialBlock}>
                    <div className={css.testimonialImg}>
                      <img
                        src="https://www.soulsearch.io/uploads/news-pictures/5851-sacramento-blog-post-image-20241104192609.png"
                        alt=""
                      />
                    </div>
                    <div className={css.testimonialDescription}>
                      <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                      <h4>How Positive Thinking Leads to Happiness, Gratitude, and Joy</h4>
                      <p>
                        When life gives me lemons, I make lemonade. If there’s water in my cup, I
                        see it as half full. That’s the way I’ve come to be, an optimist looking at
                        the bright side of life. Over the years I have come to understand that I
                        have a choice, I can find joy in the little things in life or indulge in
                        entertaining negativity. We’re all guilty of allowing things that are
                        outside of ourselves to affect our mood, it’s human!
                      </p>
                    </div>
                    <div className={css.userInfo}>
                      <div className={css.userLeft}>
                        <div className={css.authorDetails}>
                          <h3>John Smith</h3>
                          <p>Personal trainer, FitLife Gym</p>
                          <p>Edmonton, Canada</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={css.testimonialBlock}>
                    <div className={css.testimonialImg}>
                      <img
                        src="https://www.soulsearch.io/uploads/news-pictures/5789-fairfax-blog-post-image-20241029125301.jpg"
                        alt=""
                      />
                    </div>
                    <div className={css.testimonialDescription}>
                      <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                      <h4>
                        The Emperor’s New Clothes, Trump & the Democrats: A time for critical
                        thinking
                      </h4>
                      <p>
                        Critical thinking is based on a desire for truth and clarity, and a
                        commitment to look beyond our fears, biases and blind spots. If you value
                        critical thinking, I request that you read this article with an open mind.
                        See what it evokes in you. If you have some opinions that differ from mine
                        and you read it anyway, that will be a heroic act, so thank you in advance!
                      </p>
                    </div>
                    <div className={css.userInfo}>
                      <div className={css.userLeft}>
                        <div className={css.authorDetails}>
                          <h3>John Smith</h3>
                          <p>Personal trainer, FitLife Gym</p>
                          <p>Edmonton, Canada</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={css.testimonialBlock}>
                    <div className={css.testimonialImg}>
                      <img
                        src="https://www.soulsearch.io/uploads/news-pictures/5789-fairfax-blog-post-image-20240920173158.jpg"
                        alt=""
                      />
                    </div>
                    <div className={css.testimonialDescription}>
                      <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                      <h4>Holding Complexity: US Presidential Election & the 4th Dimension</h4>
                      <p>
                        Some words used to describe this year’s US Presidential election are
                        “bizarre”, “a critical choice”, “crazy”, or as Vice Presidential candidate
                        Tim Walz put it, “weird”. Have you ever wondered WHY it seems so wierd? This
                        article offers a way to understand what we’re going through as a transit
                        through dimensional states of consciousness.
                      </p>
                    </div>
                    <div className={css.userInfo}>
                      <div className={css.userLeft}>
                        <div className={css.authorDetails}>
                          <h3>John Smith</h3>
                          <p>Personal trainer, FitLife Gym</p>
                          <p>Edmonton, Canada</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={css.testimonialBlock}>
                    <div className={css.testimonialImg}>
                      <img
                        src="https://www.soulsearch.io/uploads/news-pictures/5251-menlo-park-blog-post-image-20240807221932.jpg"
                        alt=""
                      />
                    </div>
                    <div className={css.testimonialDescription}>
                      <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                      <h4>Lion's Gate Activation</h4>
                      <p>
                        As Earth, Sirius, and Orion move into alignment, at this time of the Lion's
                        Gate Portal that peaks on 8/8, may you activate your soul alignment with all
                        that you desire in this next unfolding chapter of your life. Like the lion,
                        you are called to be regal, to set your standards high and own the
                        evolutionary leadership you are here to bring in on this planet. And as a
                        star-being, may you feel the Earth and stars lining up to support you
                        magically at this potent time. Whatever you most desire, I invite you to
                        spend some time reflecting on it and setting a clear intention for this
                        Lion's Gate Portal.
                      </p>
                    </div>
                    <div className={css.userInfo}>
                      <div className={css.userLeft}>
                        <div className={css.authorDetails}>
                          <h3>John Smith</h3>
                          <p>Personal trainer, FitLife Gym</p>
                          <p>Edmonton, Canada</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplaySpeed: 3000,
  autoplay: false,
  speed: 500,
  slidesToShow: 3, // Display 4 items on desktop
  slidesToScroll: 1, // Scroll 1 item at a time
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 676,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
SectionSingleBlog.defaultProps = {
  sliderSettings,
};
export default SectionSingleBlog;
